module.exports = __webpack_public_path__ + "Package.50076d13fb2027779e34bf917599f91f.hashedasset.svg";